import React, { useState, useEffect } from "react";
import { Row, Col, Card, Avatar, Rate, Tag, Divider } from "antd";
import {
  EditOutlined,
  WechatOutlined,
  EnvironmentFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import "./WorkHistory.css";
import { Button } from "antd/lib/radio";
import noData from "../../../assets/img/Emptyjobs.png";
import moment from "moment";
import { log } from "@antv/g2plot/lib/utils";

const WorkHistory = (props) => {
  const Pdetails = useSelector(
    (state) => state.getProfileDetailsReducer.details
  );
  const [currentWorkHistory, setCurrentWorkHistory] = useState("");
  const [currentWorkHistorySkills, setCurrentWorkHistorySkills] = useState("");

  var cache = {},
    character,
    e = document.createElement("div");

  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
          character = cache[entity] = e.childNodes[0].nodeValue;
        else character = "";
      }
      return character;
    });
  };

  useEffect(() => {
    let filteredData = props.data?.filter((item) => !item.Deleted);
    setCurrentWorkHistory(filteredData);
  }, [props]);
  useEffect(() => {
    // let filteredDataSkills = currentWorkHistory?.length > 0 && currentWorkHistory[0]?.Consultants_CareerRecordSkills?.filter((item) => !item.Deleted);
    if (currentWorkHistory?.length > 0) {
      let filteredDataSkills = [
        ...new Set(currentWorkHistory?.map((item) => item)),
      ]?.map((item) => {
        return item?.Consultants_CareerRecordSkills.find(
          (item) => !item.Deleted
        );
      });
      setCurrentWorkHistorySkills(filteredDataSkills);
    }
  }, [props]);
  // console.log("cwh",currentWorkHistory[0]?.Consultants_CareerRecordSkills);
  return (
    <>
      <div className="work-history-main">
        {currentWorkHistory?.length > 0 ? (
          currentWorkHistory?.map((res, index) => {
            // if(!res.Deleted){
            return (
              <>
                <div key={index} className="workHistory-title">{res.CompanyName}</div>
                <div>{res.Title}</div>
                <div className="workHitory-items">
                  {moment(res.StartDate).format("MMMM DD, YYYY")} - {" "}
                  {res.EndDate != null
                    ? moment(res.EndDate).format("MMMM DD, YYYY")
                    : "Current"}
                </div>

                {res?.Location ||
                  (res.Cities?.CityName && (
                    <div className="workHitory-items">
                      Located in{" "}
                      {res?.Location ? res?.Location : res.Cities?.CityName}
                    </div>
                  ))}

                {res?.Consultants_CareerRecordSkills?.length > 0 && (
                  <div>
                    <div className="Work-header">Skills</div>
                    {res?.Consultants_CareerRecordSkills?.map((result, i) => {
                      if (!result?.details)
                        return (
                          <Tag className="Tags" key={i}>
                            {result?.Skills?.SkillName} - {result?.SkillPercent}
                            %
                          </Tag>
                        );
                    })}
                  </div>
                )}
              
                <div className="Work-header">{currentWorkHistory[index]
                        ?.Consultants_CareerRecords_Responsibilities[0]
                        ?.Description? "Responsibilities given" : null}</div>
                
                <div
                  dangerouslySetInnerHTML={{
                    __html: msgtxt(
                      currentWorkHistory[index]
                        ?.Consultants_CareerRecords_Responsibilities[0]
                        ?.Description
                        ? currentWorkHistory[index]
                            ?.Consultants_CareerRecords_Responsibilities[0]
                            ?.Description
                        : currentWorkHistory[index]?.Description
                        ? currentWorkHistory[index]?.Responsibilities
                        : currentWorkHistory[index]?.Responsibilities
                        ? currentWorkHistory[index]?.Responsibilities
                        : "N/A"
                    ),
                  }}
                  className="work-history-para"
                ></div>

                {currentWorkHistory?.length > 0 &&
                currentWorkHistory?.length - 1 === index ? null : (
                  <Divider />
                )}
              </>
            );
            // }
          })
        ) : (
          <>
            <div
              style={{
                width: "50%",
                margin: "auto",
              }}
            >
              <img src={noData} style={{ width: "100%" }} />
            </div>
            <div style={{ textAlign: "center" }}>No Work history !</div>
          </>
        )}
      </div>
    </>
  );
};
export default WorkHistory;
